import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import './RootRedirect.css';

const RootRedirect: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M21 12a9 9 0 11-6.219-8.56" />
          </svg>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  // If user is authenticated, redirect to dashboard
  // If user is not authenticated, redirect to login
  return <Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />;
};

export default RootRedirect;
